module.exports = __webpack_public_path__ + "static/scesoc-14cd92016050feb31ad4ba2bd162d98f.png";